import { BaseTabRenderer } from "./BaseTabRenderer";

export class TransactionsRenderer extends BaseTabRenderer {
    getListId() {
        return "accordionTransactions";
    }

    getListDataName() {
        return "transactionsList";
    }

    getPaginationTemplateId() {
        return "transactions-pagination-template";
    }

    getPaginationDataName() {
        return "transactionsPagination";
    }

    getPageParamName() {
        return "transactions_page";
    }

    getPaginationLinkTemplateId() {
        return "transactions-pagination-link-template";
    }

    createItemNode(item) {
        const template = this.find("#transaction-item-template");
        if (!(template instanceof HTMLTemplateElement)) {
            return document.createElement("div");
        }

        const node = template.content.firstElementChild.cloneNode(true);
        const itemId = String(item.id);
        const collapseId = `transaction-collapse-${itemId}`;
        const headingId = `transaction-heading-${itemId}`;

        this.setText(node, "createdAtShort", item.created_at_short);
        this.setText(node, "typeLabel", item.type_label);
        this.setText(node, "dateHeader", item.labels?.date);
        this.setText(node, "dateValue", item.created_at_short);
        this.setText(node, "billHeader", item.labels?.bill);
        this.setText(node, "billValue", item.subscription_label);
        this.setText(node, "operationTypeHeader", item.labels?.operation_type);
        this.setText(node, "operationTypeValue", item.operation_type_label);
        this.setText(node, "amountHeader", item.labels?.amount);
        this.setText(node, "amountValue", item.amount_label);
        this.setText(node, "balanceHeader", item.labels?.balance);
        this.setText(node, "balanceValue", item.balance_label);

        const header = node.querySelector(".accordion-header");
        header.id = headingId;

        const button = node.querySelector(".accordion-button");
        button.setAttribute("data-bs-target", `#${collapseId}`);
        button.setAttribute("aria-controls", collapseId);

        const collapse = this.getField(node, "collapseRoot");
        collapse.id = collapseId;
        collapse.setAttribute("aria-labelledby", headingId);
        collapse.setAttribute("data-bs-parent", "#accordionTransactions");

        if (item.entity) {
            const entityRow = this.getField(node, "entityRow");
            const entityLink = this.getField(node, "entityLink");
            entityRow.classList.remove("d-none");
            this.setText(node, "entityLabel", item.entity.label);
            entityLink.textContent = item.entity.target_label ?? "";
            entityLink.href = item.entity.url || "#";
            if (item.entity.target_blank) {
                entityLink.setAttribute("target", "_blank");
            } else {
                entityLink.removeAttribute("target");
            }
        }

        return node;
    }

}

export default TransactionsRenderer;
